import React, {PropsWithChildren} from 'react';
import RoomPlannerPdfHeader from './RoomPlannerPdfHeader';

type TitleProps = {
    title?: string;
    subTitle: string;
};

const RoomPlannerPdfLayout = ({children}: PropsWithChildren) => children;

const Page = ({
    title,
    subTitle,
    children,
}: React.PropsWithChildren<TitleProps>) => {
    return (
        <div className="new-page">
            <RoomPlannerPdfHeader title={title} subTitle={subTitle} />
            {children}
        </div>
    );
};

RoomPlannerPdfLayout.Page = Page;

export default RoomPlannerPdfLayout;
